export default {
  FROM_TAG: 'fromTag',
  // 旧运营使用的utm_source和运营位 TODO 后面会整体切换
  STATS_TAG: 'utm_content',
  // 演出内部运营位的标志符 TODO 暂时使用 utm_content做临时方案, 之后会统一修改

  // Regx
  STATS_TAG_REGX: /utm_content/,
  FROM_TAG_REGX: /fromTag/
};